import { createContext as At, useState as E, useEffect as U, useMemo as F, useId as Mt, useRef as b, useReducer as Et, useCallback as N, useContext as Rt } from "react";
import { u as wt, a as Tt, i as Vt, o as bt, f as Nt, s as Wt, b as zt, c as Yt, d as jt, e as Ut, g as P, h as Ht } from "./floating-ui.react.MkaYL6o7.js";
import { d as r, c as Lt } from "./customParseFormat.VB0eI5Wm.js";
const Ft = (t) => {
  const n = r();
  return r.locale(t), Array.from(Array(C)).map((p, l) => {
    const h = n.day(l + 1);
    return {
      abbr: h.format("dddd"),
      day: h.day(),
      label: h.format("dd")
    };
  });
}, Pt = (t = !1, n = !1, v) => {
  const p = r();
  p.locale(v);
  const l = p.month();
  return Array.from(Array(Kt)).map((y, _) => {
    const a = p.month(_), c = a.month(), u = t && c > l || n && c < l;
    return {
      month: a.month(),
      label: a.format("MMMM"),
      disabled: u
    };
  });
}, Ct = (t = 1900, n = 2100, v = !1, p = !1, l) => {
  const h = r(), y = h.year();
  return h.locale(l), Array.from({ length: n - t + 1 }).map(
    (a, c) => {
      const u = h.year(t + c), d = u.year(), k = v && d > y || p && d < y;
      return {
        year: u.year(),
        label: u.format("YYYY"),
        disabled: k
      };
    }
  );
}, Bt = (t, {
  dynamicNumberOfRows: n = !1,
  disablePast: v = !1,
  disableFuture: p = !1,
  dateValidator: l,
  minDate: h,
  maxDate: y
}) => {
  const u = g(r()), d = g(t), w = (d.date(1).day() + 6) % C, M = d.daysInMonth(), H = n ? M + w === 28 ? 28 : M + w <= 35 ? 35 : 42 : 42, W = d.date(1).subtract(w, "day"), z = [];
  for (let m = 0; m < H; m++) {
    const i = W.add(m, "day");
    z.push({
      date: i,
      day: i.date(),
      isCurrentMonth: i.isSame(d, "month"),
      label: `${i.date()}`,
      isToday: i.isSame(u, "day"),
      disabled: Xt(i, {
        disableFuture: p,
        disablePast: v,
        dateValidator: l,
        minDate: h,
        maxDate: y
      })
    });
  }
  return z;
}, Xt = (t, {
  disablePast: n = !1,
  disableFuture: v = !1,
  dateValidator: p,
  minDate: l,
  maxDate: h
}) => R(t, {
  precision: "date",
  disableFuture: v,
  disablePast: n,
  minDate: l,
  maxDate: h
}).isValid ? p ? !p(t.toDate()) : !1 : !0, $t = (t, n) => {
  switch (n.action) {
    case "selectDate":
      return {
        ...t,
        selectedDate: n.value,
        activeDate: n.value
      };
    case "changeActiveDate":
      return {
        ...t,
        activeDate: n.value
      };
    case "changeActiveDateIndex":
      return {
        ...t,
        activeDateIndex: n.value
      };
    case "changeActiveMonthIndex":
      return {
        ...t,
        activeMonthIndex: n.value
      };
    case "changeActiveYearIndex":
      return {
        ...t,
        activeYearIndex: n.value
      };
    default:
      return t;
  }
}, qt = {
  af: () => import("./af.CjMcMfHA.js").then((t) => t.a),
  am: () => import("./am.T1wIj5yI.js").then((t) => t.a),
  ar: () => import("./ar.D86HQhRG.js").then((t) => t.a),
  az: () => import("./az.CMN9-oM5.js").then((t) => t.a),
  bg: () => import("./bg.VDhwdqZg.js").then((t) => t.b),
  bm: () => import("./bm.VR3Iw0OS.js").then((t) => t.b),
  bn: () => import("./bn.Dn3TPCka.js").then((t) => t.b),
  bo: () => import("./bo.Xhw7P-Xk.js").then((t) => t.b),
  br: () => import("./br.ihNmSoUV.js").then((t) => t.b),
  bs: () => import("./bs.FryyVYvu.js").then((t) => t.b),
  ca: () => import("./ca.BUmOJk16.js").then((t) => t.c),
  cs: () => import("./cs.C0PCZpas.js").then((t) => t.c),
  cv: () => import("./cv.ChhNt--a.js").then((t) => t.c),
  cy: () => import("./cy.DRA6X61v.js").then((t) => t.c),
  da: () => import("./da.ZP8UmFm0.js").then((t) => t.d),
  de: () => import("./de.Deh1j0DH.js").then((t) => t.d),
  dv: () => import("./dv.DcUIDbX1.js").then((t) => t.d),
  el: () => import("./el.X1OBUQue.js").then((t) => t.e),
  en: () => import("./en.DDSqDg5E.js").then((t) => t.e),
  eo: () => import("./eo.B2QVUKha.js").then((t) => t.e),
  es: () => import("./es.BZwCh83Z.js").then((t) => t.e),
  et: () => import("./et.Cg5IlZxV.js").then((t) => t.e),
  eu: () => import("./eu.UbLzSMRI.js").then((t) => t.e),
  fa: () => import("./fa.CvNSOwN8.js").then((t) => t.f),
  fi: () => import("./fi.Dg9Guvfj.js").then((t) => t.f),
  fo: () => import("./fo.DsOdI1EI.js").then((t) => t.f),
  fr: () => import("./fr.BTbeTXAW.js").then((t) => t.f),
  fy: () => import("./fy.Y4CmU8G7.js").then((t) => t.f),
  ga: () => import("./ga.ZaZTmqX_.js").then((t) => t.g),
  gd: () => import("./gd.Bt14Oq8b.js").then((t) => t.g),
  gl: () => import("./gl.Bww8vkZT.js").then((t) => t.g),
  gu: () => import("./gu.CPPLu1J4.js").then((t) => t.g),
  he: () => import("./he.CHV6zh89.js").then((t) => t.h),
  hi: () => import("./hi.MQVEkzyM.js").then((t) => t.h),
  hr: () => import("./hr.rqu4300Y.js").then((t) => t.h),
  ht: () => import("./ht.CKbt3gvQ.js").then((t) => t.h),
  hu: () => import("./hu.Dt4hw6EM.js").then((t) => t.h),
  "hy-am": () => import("./hy-am.CaqdRKev.js").then((t) => t.h),
  id: () => import("./id.Z_WlfJhn.js").then((t) => t.i),
  is: () => import("./is.qwR1Uiev.js").then((t) => t.i),
  it: () => import("./it.DdLp_p_a.js").then((t) => t.i),
  ja: () => import("./ja.B2sOhxOl.js").then((t) => t.j),
  jv: () => import("./jv.BnzlL1wm.js").then((t) => t.j),
  ka: () => import("./ka.bLmBV0M7.js").then((t) => t.k),
  kk: () => import("./kk.erUbTWjd.js").then((t) => t.k),
  km: () => import("./km.C0pV3Tr7.js").then((t) => t.k),
  kn: () => import("./kn.JSHGVEWJ.js").then((t) => t.k),
  ko: () => import("./ko.Cnb16tgB.js").then((t) => t.k),
  ku: () => import("./ku.a0eU8zis.js").then((t) => t.k),
  ky: () => import("./ky.DMOkvft7.js").then((t) => t.k),
  lb: () => import("./lb.C1LeSBkU.js").then((t) => t.l),
  lo: () => import("./lo.CdDau4ma.js").then((t) => t.l),
  lt: () => import("./lt.BB_0qOsg.js").then((t) => t.l),
  lv: () => import("./lv.IJeldAae.js").then((t) => t.l),
  me: () => import("./me.D_fRNwks.js").then((t) => t.m),
  mi: () => import("./mi.BDLb_XbI.js").then((t) => t.m),
  mk: () => import("./mk.CSc5RB4H.js").then((t) => t.m),
  ml: () => import("./ml.BcbRQ6zk.js").then((t) => t.m),
  mn: () => import("./mn.rYdvmnYn.js").then((t) => t.m),
  mr: () => import("./mr.ClvFbMfF.js").then((t) => t.m),
  ms: () => import("./ms.B5qYLaQU.js").then((t) => t.m),
  mt: () => import("./mt.CywL9xK2.js").then((t) => t.m),
  my: () => import("./my.CXxcC476.js").then((t) => t.m),
  nb: () => import("./nb.DaiaJs8A.js").then((t) => t.n),
  ne: () => import("./ne.-g5mMBGx.js").then((t) => t.n),
  nl: () => import("./nl.WUbdlMbY.js").then((t) => t.n),
  nn: () => import("./nn.CnmUAS2U.js").then((t) => t.n),
  "oc-lnc": () => import("./oc-lnc.ClhsO3N0.js").then((t) => t.o),
  "pa-in": () => import("./pa-in.DWMHbTfI.js").then((t) => t.p),
  pl: () => import("./pl.CuIpfI9K.js").then((t) => t.p),
  pt: () => import("./pt.DvNgjYzs.js").then((t) => t.p),
  rn: () => import("./rn.DtaJ9l8X.js").then((t) => t.r),
  ro: () => import("./ro.DG84xunX.js").then((t) => t.r),
  ru: () => import("./ru.DeEFZ8Ec.js").then((t) => t.r),
  rw: () => import("./rw.CuFDfhmu.js").then((t) => t.r),
  sd: () => import("./sd.CV9OnvBs.js").then((t) => t.s),
  se: () => import("./se.DMA_RERp.js").then((t) => t.s),
  si: () => import("./si.B9p0-sfT.js").then((t) => t.s),
  sk: () => import("./sk.X4Ntb5AY.js").then((t) => t.s),
  sl: () => import("./sl.COCh19lW.js").then((t) => t.s),
  sq: () => import("./sq.DsOttcML.js").then((t) => t.s),
  sr: () => import("./sr.DhvLlXrl.js").then((t) => t.s),
  ss: () => import("./ss.DNeW5uSY.js").then((t) => t.s),
  sv: () => import("./sv.CH5LmZBK.js").then((t) => t.s),
  sw: () => import("./sw.DL_Hk-qm.js").then((t) => t.s),
  ta: () => import("./ta.DBVLTB43.js").then((t) => t.t),
  te: () => import("./te.DX62SRpB.js").then((t) => t.t),
  tg: () => import("./tg.kTROjVUf.js").then((t) => t.t),
  th: () => import("./th.DYKCERKD.js").then((t) => t.t),
  tk: () => import("./tk.hc81exQb.js").then((t) => t.t),
  tlh: () => import("./tlh.uuLapBp-.js").then((t) => t.t),
  tr: () => import("./tr.Dk20BoCN.js").then((t) => t.t),
  tzl: () => import("./tzl.CJ9vykNn.js").then((t) => t.t),
  tzm: () => import("./tzm.k8S9kpYH.js").then((t) => t.t),
  "ug-cn": () => import("./ug-cn.DVPC0H9l.js").then((t) => t.u),
  uk: () => import("./uk.DRt9UVUY.js").then((t) => t.u),
  ur: () => import("./ur.Drnfy7fW.js").then((t) => t.u),
  uz: () => import("./uz.AzzbV6Sm.js").then((t) => t.u),
  vi: () => import("./vi.CKtfB8Q-.js").then((t) => t.v),
  yo: () => import("./yo.Bw1wIqN_.js").then((t) => t.y),
  zh: () => import("./zh.Cle1tFMa.js").then((t) => t.z)
}, C = 7, Kt = 12, ht = /* @__PURE__ */ new Date("1900-01-01"), pt = /* @__PURE__ */ new Date("2100-12-31"), Gt = At(
  null
), te = () => {
  const t = Rt(Gt);
  if (r.extend(Lt), t == null)
    throw new Error("DatePicker components must be wrapped in <DatePicker />");
  return t;
}, R = (t, {
  precision: n,
  disablePast: v = !1,
  disableFuture: p = !1,
  minDate: l,
  maxDate: h,
  dateValidator: y
}) => {
  const _ = r();
  return t.isValid() ? v && t.isBefore(_, n) ? { isValid: !1, error: "disablePast" } : p && t.isAfter(_, n) ? { isValid: !1, error: "disableFuture" } : l && t.isBefore(r(l), n) ? { isValid: !1, error: "minDate" } : h && t.isAfter(r(h), n) ? { isValid: !1, error: "maxDate" } : y && !y(t.toDate()) ? { isValid: !1, error: "notAllowedDate" } : { isValid: !0 } : { isValid: !1, error: "invalidDate" };
}, g = (t) => (r.isDayjs(t) ? t : r(t)).startOf("day");
function ee({
  defaultOpen: t = !1,
  open: n,
  onOpenChange: v,
  locale: p = "en",
  minDate: l = ht,
  maxDate: h = pt,
  defaultDate: y,
  size: _,
  disableFuture: a = !1,
  disablePast: c = !1,
  dateValidator: u,
  onMonthChange: d,
  onYearChange: k,
  disableCalendar: w,
  containerRef: M,
  flip: H = !0
}) {
  const [W, z] = E(r.locale());
  U(() => {
    qt[p]().then(() => {
      r.locale(p), z(p);
    });
  }, [p]);
  const m = F(() => g(
    r(l).isValid() ? r(l) : r(ht)
  ), [l]), i = F(() => g(
    r(h).isValid() ? r(h) : r(pt)
  ), [h]), tt = Mt(), lt = b(null), dt = b(null), [T, Y] = E(t), [ut, ft] = E(t), j = n ?? ut, et = v ?? ft;
  U(() => {
    et(T);
  }, [T, et]);
  const L = b([]), B = b([]), X = b([]), [S, vt] = E(), [D, $] = E("date"), q = y ? r(y) : void 0, [yt, x] = Et($t, {
    defaultDate: y,
    selectedDate: q,
    activeDate: q,
    activeDateIndex: null,
    activeMonthIndex: null,
    activeYearIndex: null
  }), {
    activeDate: A,
    selectedDate: s,
    activeDateIndex: K,
    activeMonthIndex: G,
    activeYearIndex: J
  } = yt, [I, V] = E(
    g((q ?? r()).startOf("month"))
  ), It = [
    Vt(),
    bt({
      mainAxis: 12,
      crossAxis: 9
    }),
    H && Nt(),
    Wt({
      apply({ elements: e, availableWidth: o, availableHeight: f }) {
        var mt;
        Object.assign(e.floating.style, {
          maxHeight: `${f}px`,
          maxWidth: `${o - (_ === "large" ? 4 : 6)}px`,
          width: `${Math.max(480, ((mt = M == null ? void 0 : M.current) == null ? void 0 : mt.clientWidth) ?? 0)}px`
        });
      }
    })
  ], O = wt({
    placement: "bottom-end",
    open: T,
    onOpenChange: Y,
    middleware: It,
    whileElementsMounted: Tt,
    transform: !1,
    elements: {}
  }), { isMounted: nt, styles: ot } = zt(O.context, {
    duration: 200,
    initial: { opacity: 0 },
    open: { opacity: 1 },
    close: { opacity: 0 }
  }), Q = O.context, xt = Yt(Q, {
    enabled: !n
  }), Dt = jt(Q, {
    enabled: !n && !w
  }), _t = Ut(Q, { role: "dialog" }), St = (e) => {
    if (e !== null && e > -1 && S && S.length > e) {
      const o = S[e].date;
      o && x({ action: "changeActiveDate", value: o });
    }
  }, Ot = P(O.context, {
    enabled: D === "date",
    listRef: X,
    activeIndex: K,
    selectedIndex: S == null ? void 0 : S.findIndex(
      (e) => e.date.isSame(s, "date")
    ),
    focusItemOnOpen: !0,
    focusItemOnHover: !1,
    orientation: "horizontal",
    onNavigate: St,
    cols: C
  }), gt = P(O.context, {
    enabled: D === "year",
    listRef: L,
    activeIndex: J,
    selectedIndex: s ? (s == null ? void 0 : s.year()) - m.year() : null,
    focusItemOnOpen: !0,
    focusItemOnHover: !1,
    scrollItemIntoView: !0,
    onNavigate: (e) => {
      x({ action: "changeActiveYearIndex", value: e });
    },
    disabledIndices: []
  }), kt = P(O.context, {
    enabled: D === "month",
    listRef: B,
    activeIndex: G,
    selectedIndex: s ? s == null ? void 0 : s.month() : null,
    focusItemOnOpen: !0,
    focusItemOnHover: !1,
    scrollItemIntoView: !0,
    onNavigate: (e) => {
      x({ action: "changeActiveMonthIndex", value: e });
    },
    disabledIndices: []
  }), rt = Ht([
    xt,
    _t,
    Dt,
    Ot,
    gt,
    kt
  ]);
  U(() => {
    const e = Bt(I, {
      disableFuture: a,
      disablePast: c,
      minDate: m,
      maxDate: i,
      dateValidator: u
    });
    if (vt(e), j && A)
      if (D === "date") {
        const o = e.findIndex(
          (f) => f.date.isSame(A, "date")
        );
        o > -1 && x({ action: "changeActiveDateIndex", value: o });
      } else D === "year" ? x({
        action: "changeActiveYearIndex",
        value: A.year() - m.year()
      }) : D === "month" && x({
        action: "changeActiveMonthIndex",
        value: A.month()
      });
  }, [
    I,
    A,
    D,
    j,
    a,
    c,
    m,
    i,
    u
  ]), U(() => {
    if (!j) {
      const e = s || g(r());
      V(e), x({ action: "changeActiveDate", value: r(s) }), $("date");
    }
  }, [j, s]);
  const st = N(
    (e) => {
      const o = g(
        r(I).subtract(1, "month")
      ), { isValid: f } = R(o, {
        precision: "month",
        minDate: m,
        maxDate: i,
        disableFuture: a,
        disablePast: c
      });
      f && (V(o), d == null || d(o.toDate(), e));
    },
    [I, m, i, a, c, d]
  ), it = N(
    (e) => {
      const o = g(r(I).add(1, "month")), { isValid: f } = R(o, {
        precision: "month",
        minDate: m,
        maxDate: i,
        disableFuture: a,
        disablePast: c
      });
      f && (V(o), d == null || d(o.toDate(), e));
    },
    [I, m, i, a, c, d]
  ), at = N(
    (e) => {
      const o = s == null ? void 0 : s.month(e);
      if (o && R(o, {
        precision: "month",
        minDate: m,
        maxDate: i,
        disablePast: c,
        disableFuture: a
      }).isValid) {
        const f = I.month(e);
        V(f), x({ action: "selectDate", value: o });
      }
    },
    [I, s, m, i, c, a]
  ), ct = N(
    (e) => {
      const o = s == null ? void 0 : s.year(e);
      if (o && R(o, {
        precision: "year",
        minDate: m,
        maxDate: i,
        disablePast: c,
        disableFuture: a
      }).isValid) {
        const f = I.year(e);
        V(f), k == null || k(f.toDate(), "yearSelector"), x({ action: "selectDate", value: o });
      }
    },
    [
      I,
      s,
      m,
      i,
      c,
      a,
      k
    ]
  ), Z = N(
    (e) => {
      const o = e !== void 0 && R(e, {
        precision: "date",
        minDate: m,
        maxDate: i,
        disablePast: c,
        disableFuture: a,
        dateValidator: u
      }).isValid;
      x({
        action: "selectDate",
        value: o ? e : void 0
      }), Y(!1);
    },
    [m, i, c, a, u]
  );
  return F(() => {
    const [e, o] = O.placement.split("-");
    return {
      elementId: tt,
      locale: W,
      open: T,
      setOpen: Y,
      ...rt,
      ...O,
      listRef: X,
      yearListRef: L,
      monthListRef: B,
      alignment: o,
      placement: e,
      renderedMonth: I,
      selectedDate: s,
      minDate: m,
      maxDate: i,
      disablePast: c,
      disableFuture: a,
      activeDateIndex: K,
      activeDate: A,
      activeMonthIndex: G,
      activeYearIndex: J,
      calendarItems: S,
      view: D,
      setView: $,
      setSelectedDate: (f) => Z(f),
      goToPreviousMonth: st,
      goToNextMonth: it,
      selectDate: Z,
      selectMonth: at,
      selectYear: ct,
      isMounted: nt,
      menuStyles: ot,
      dateValidator: u,
      monthSelectionButtonRef: dt,
      yearSelectionButtonRef: lt
    };
  }, [
    T,
    Y,
    rt,
    O,
    X,
    B,
    L,
    tt,
    I,
    s,
    W,
    m,
    i,
    c,
    a,
    K,
    A,
    G,
    J,
    S,
    D,
    $,
    st,
    it,
    at,
    ct,
    Z,
    nt,
    ot,
    u
  ]);
}
export {
  Gt as D,
  ht as a,
  pt as b,
  te as c,
  R as d,
  Pt as e,
  Ct as f,
  Ft as g,
  C as h,
  ee as u
};
//# sourceMappingURL=ODSDatePicker.utils.Dvmx0txe.js.map
